<template>
  <div class="alreadyCompletedBox">
    <p class="alreadyCompletedText">
      {{ $fanyi("此问卷已完成填写并提交，无需再次填写") }}
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped="scoped">
.alreadyCompletedBox {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px 24px;
}

.alreadyCompletedText {
  margin: 0;
  color: #344054;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 350px;
}
</style>
